const PersonalDetailsValidationMessages = {
  english: {
    custom: {
      firstName: {
        required: 'Please enter your first name'
      },
      lastName: {
        required: 'Please enter your last name'
      },
      telephone: {
        required: 'Please enter your phone number'
      },
      email: {
        required: 'Please enter your email',
        email: 'Please enter a valid email'
      }
    },
    messages: {
      twilio: (field: any) => 'Please enter a valid phone number'
    }
  }
};

export default PersonalDetailsValidationMessages;
